import { Box, Button, Card, CardContent, IconButton, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import ReactQuill from "react-quill"
import './index.scss'

interface NoteProps {
    handleModal: (open: boolean) => void,
    handleModalDelete: (open: boolean, needEvent: boolean, event?: any) => void,
    handleInfoToEditModal: (editTitle: string, editContent: string, idNote: number) => void,
    handleInfoToDelete: (idNote: number) => void
    content: string,
    title: string,
    idNote: number,
    edit?: boolean,
}

const NoteCard = (props: NoteProps) => {

    const {
        handleModal,
        handleModalDelete,
        handleInfoToEditModal,
        handleInfoToDelete,
        edit = false,
        title,
        content,
        idNote } = props

    return (
        <Card
            sx={{
                width: '294px',
                height: '340px',
                margin: '8px'
            }}
            onClick={edit ?
                undefined :
                () => {
                    handleModal(true)
                    handleInfoToEditModal(title, content, idNote)
                }}
        >
            <CardContent
                sx={{
                    padding: '16px'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}
                >
                    <IconButton
                        onClick={(e) => {
                            handleModalDelete(true, true, e)
                            handleInfoToDelete(idNote)
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        paddingX: '16px',
                        marginTop: '-16px'
                    }}
                >
                    <Typography
                        component='h3'
                        sx={{
                            marginBottom: '8px',
                            fontWeight: 500
                        }}
                    >
                        {title ? title : ''}
                    </Typography>
                    <ReactQuill
                        readOnly
                        value={content}
                        modules={{
                            toolbar: false
                        }}
                        className="ql-editor ql-editor-height-card"
                    />
                </Box>
            </CardContent>
        </Card >
    )
}

export default NoteCard